import axios from 'axios'

export const fetchPartner = async() => {
  try {
    return await axios.get(`partner`)
  } catch (error) {
    throw error.response
  }
}
